<template>
    <div>
        <Row :gutter="8">
            <div class="w-full flex justify-end">
                <div class="mr-2">
                    <p>Filtrar por Cliente</p>
                    <i-select filterable v-model="filters.companyId" clearable @on-clear="() => filters.companyId = 0" @on-change="loadChart" class="w-64">
                        <Option v-for="company in companies" :value="company.value" :key="company.value">{{ company.label }}</Option>
                    </i-select>
                </div>
                <div class="mr-2">
                    <p>Filtrar por vendedor</p>
                    <i-select filterable v-model="filters.salerId" clearable @on-clear="() => filters.salerId = 0" @on-change="loadChart" class="w-64" :disabled="filters.companyId !== 0">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
                </div>
            </div>
        </Row>
        <Spin size="large" fix v-if="chart.metadata.loading"></Spin>
        <echart :options="chart.options" @click="getCustomersByStatus"></echart>
            <div v-show="metadata.showTable">
                <div @scroll="loadMoreCompanies" class="overflow-auto h-auto" style="max-height:32rem;">
                    <i-table ref="table" :columns="table.columns" :data="table.data" :loading="metadata.loading"/>
                </div>
                <br />
                <span class="mt-2"> Exibindo {{metadata.page + 1}}-{{Math.floor(metadata.companiesNumber / config.companiesNumberPerPage) + 1}} de {{metadata.companiesNumber}}</span>
            </div>
    </div>
</template>

<script>
import clienteMixin from './Mixins/ClienteMixin';
export default {
    mixins: [clienteMixin],
    name: 'ativos',
    data () {
        return {
            config: {
                status: 'ativos'
            }
        }
    },

    methods: {
        async loadChart()
        {
            this.clearMetadata();
            let actives = await this.getChart("actives");
            let newActives = await this.getChart("newActives");

            const newActivesData = this.defaultingChart(newActives);
            const activesData = this.defaultingChart(actives);
            const total = await this.getChart("total");
            this.chart.options.xAxis = [
                {
                    type : 'category',
                    data : this.config.monthRange,
                    axisLine: {onZero: true},
                    splitLine: {show: false},
                    splitArea: {show: false},
                }
            ]
            this.chart.options.legend = {
                data: [{name: 'Ativos', alias: 'actives'}, {name: 'Novos Clientes', alias: 'newActives'}, {name: 'Total', alias: 'total'}]
            }
            this.chart.options.series = [
                {
                    name: 'Ativos',
                    type: 'bar',
                    color:'#20B2AA',
                    stack:'clientes',
                    data:activesData,
                    label:{
                        normal:{
                            position:'inside',
                            show:true,
                            color:'#ffffff'
                        }
                    }
                },
                {
                    name:'Novos Clientes',
                    type:'bar',
                    color:'#48D1CC',
                    stack:'clientes',
                    data:newActivesData,
                    label:{
                        normal:{
                            position:'inside',
                            show:true,
                        }
                    }
                },
                {
                    name:'Total',
                    type:'line',
                    markLine:{
                        lineStyle:{
                            color:'#00FFFF'
                        }
                    },
                    label:{
                        normal:{
                            position:'top',
                            show:true
                        }
                    },
                    stack:'clientes',
                    data:this.defaultingChart(total).map(periodo => ({value: periodo.value, profit: periodo.profit, avgProfit: periodo.avgProfit}))
            }
            ]
            this.chart.metadata.loading = false;
        }
    }
}
</script>

<style scoped>

</style>